/**
 * Invalid URL that ensures we don't make a network request
 * Can be used as a default value for URLs. Using an empty
 * string can still result in request being made to the current page
 */
export default 'https://invalid';
